import { gql } from "@apollo/client";

export default gql`
  mutation askAiCreateOrUpdateSkill(
    $id: UUID
    $name: String!
    $description: String!
    $body: String!
    $organizationId: Int
  ) {
    createOrUpdateSkill(
      id: $id
      name: $name
      description: $description
      body: $body
      organizationId: $organizationId
    ) {
      skill {
        id
        name
        slug
        description
        body
        updated
      }
    }
  }
`;
